import { render, staticRenderFns } from "./dialogPhone.vue?vue&type=template&id=d18c1afa&scoped=true&"
import script from "./dialogPhone.vue?vue&type=script&lang=js&"
export * from "./dialogPhone.vue?vue&type=script&lang=js&"
import style0 from "./dialogPhone.vue?vue&type=style&index=0&id=d18c1afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18c1afa",
  null
  
)

export default component.exports